var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepperUnfilledRadio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 31 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Oval Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stepper-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MacBook-Air-13\"",
    transform: "translate(-22.000000, -683.000000)",
    stroke: "#C8C8C8",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy",
    transform: "translate(37.500000, 699.000000) rotate(90.000000) translate(-37.500000, -699.000000) ",
    cx: 37.5,
    cy: 699,
    rx: 14.5,
    ry: 14
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperUnfilledRadio);
export default __webpack_public_path__ + "static/media/stepper_unfilled_radio.11fd191bbbbbf5436aa762ffcf35dfed.svg";
export { ForwardRef as ReactComponent };